import { Fragment } from "react";
import styled, { useTheme } from "styled-components";

import SpecificationList from "./SpecificationList";
import ClearSpecificationsButton from "./ClearSpecificationsButton";

const WorkingArea = () => {
  const theme = useTheme();
  return (
    <Fragment>
      <Specifications theme={theme}>
        <SpecificationList />
      </Specifications>
      <ClearSpecificationsButton />
    </Fragment>
  );
}

const Specifications = styled.div`
  flex: 1;  
  overflow-x: auto;
  
  column-count: 4;
  column-gap: 20px;

  @media (max-width: 1300px) {
    column-count: 3;
  }

  @media (max-width: 1000px) {
    column-count: 2;
  }

  @media (max-width: 600px) {
    column-count: 1;
  }

  & > * {
    break-inside: avoid;
    margin-bottom: 20px;
    width: 100%;
  }
`;

export default WorkingArea;
